var _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1920 1080",
    width: 1920,
    height: 1080,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1920,
    height: 1080,
    fill: "#00233e"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "43.8%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#005ab4",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#005ab4",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "43.8%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#005ab4",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#003f77",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_2",
    x1: "43.8%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#00233e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#003f77",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "100%",
    x2: "56.3%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#005ab4",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#005ab4",
    stopOpacity: 1
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "100%",
    x2: "56.3%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#003f77",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#005ab4",
    stopOpacity: 1
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_2",
    x1: "0%",
    y1: "100%",
    x2: "56.3%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "14.444444444444446%",
    stopColor: "#003f77",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85.55555555555554%",
    stopColor: "#00233e",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1920, 1080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-972 0C-874.7 -92.1 -777.4 -184.2 -744.6 -308.4C-711.8 -432.7 -743.5 -589 -687.3 -687.3C-631.1 -785.7 -487 -826 -357.8 -863.8C-228.6 -901.6 -114.3 -936.8 0 -972L0 0Z",
    fill: "#00315a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-648 0C-583.1 -61.4 -518.3 -122.8 -496.4 -205.6C-474.6 -288.4 -495.7 -392.6 -458.2 -458.2C-420.7 -523.8 -324.7 -550.7 -238.5 -575.9C-152.4 -601.1 -76.2 -624.5 0 -648L0 0Z",
    fill: "#004c95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-324 0C-291.6 -30.7 -259.1 -61.4 -248.2 -102.8C-237.3 -144.2 -247.8 -196.3 -229.1 -229.1C-210.4 -261.9 -162.3 -275.3 -119.3 -287.9C-76.2 -300.5 -38.1 -312.3 0 -324L0 0Z",
    fill: "#005ab4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M972 0C969.1 138.6 966.2 277.2 898 372C829.9 466.7 696.5 517.7 603.2 603.2C509.9 688.6 456.6 808.6 362.8 875.8C268.9 943.1 134.5 957.5 0 972L0 0Z",
    fill: "#00315a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648 0C646.1 92.4 644.1 184.8 598.7 248C553.2 311.2 464.3 345.1 402.1 402.1C339.9 459.1 304.4 539.1 241.9 583.9C179.3 628.7 89.6 638.4 0 648L0 0Z",
    fill: "#004c95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 0C323 46.2 322.1 92.4 299.3 124C276.6 155.6 232.2 172.6 201.1 201.1C170 229.5 152.2 269.5 120.9 291.9C89.6 314.4 44.8 319.2 0 324L0 0Z",
    fill: "#005ab4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLogin);
export default __webpack_public_path__ + "static/media/bg-login.1cbedcbff2d3300731596d570447c14b.svg";
export { ForwardRef as ReactComponent };